import { Quote } from "@shared/models/quotes.model";
import { filter as lodashFilter } from 'lodash';

/**
 * Retrieves the index of a quote within an array of quotes based on the provided tariff ID.
 *
 * @param quotes - An array of Quote objects to search through.
 * @param tariffId - The tariff ID to match against the quotes' TariffId property.
 * @returns The index of the quote with the matching tariff ID, or -1 if no match is found.
 */
export function getQuoteIndexByTariffId(quotes: Quote[], tariffId: number): number {
  return quotes.findIndex(quote => quote.TariffId === tariffId);
}

/**
 * Filters an array of Quote objects based on the provided filter key.
 * @param quotes  - An array of Quote objects to filter.
 * @param filterKey - An object containing the properties to filter the quotes by.
 * @returns - An array of Quote objects that match the provided filter key.
 */
export function getFilteredQuotes(quotes: Quote[], filterKey: Partial<Quote>): Quote[] {
  return lodashFilter(quotes, filterKey);
}


export function getEVChargesText(dayRate: number, offPeakRate: number, isOwnEV = false): string[] {
  return [
    `The total EV charging cost is calculated based on your vehicle's battery capacity, home charging duration, and the electricity rates in your EV tariff.`,
    `${isOwnEV ? 'According to your charging habits' : 'Using industry standard charging habits'}, we've assumed that ${offPeakRate}% of your EV energy use is charged at the off-peak rate and ${dayRate}% at the standard rate. A daily standing charge is also applied proportionally, depending on your EV usage.`,
    `The calculation differs depending on whether you already own an EV or not. To keep estimates realistic, the EV charging portion is capped at 60% of your total household electricity consumption.`
  ];
}